var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 11.1708V0.829227C0.333496 0.533084 0.435715 0.303699 0.640153 0.141069C0.844592 -0.0215609 1.06116 -0.0435761 1.28985 0.0750229L11.2519 5.20105C11.5285 5.34877 11.6668 5.61509 11.6668 6C11.6668 6.38491 11.5285 6.65123 11.2519 6.79894L1.28985 11.925C1.06116 12.0436 0.844592 12.0216 0.640153 11.8589C0.435715 11.6963 0.333496 11.4669 0.333496 11.1708ZM1.48823 10.3058L9.77144 6L1.48823 1.69422V4.82395L5.40461 6L1.48823 7.17605V10.3058Z",
    fill: "#154365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.359ca94ea12400c56f1d3688c6ba0447.svg";
export { ForwardRef as ReactComponent };